import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  Creators as RecoverPasswordActions,
  Types as RecoverPasswordTypes,
} from 'store/ducks/RecoverPassword';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* sendEmail({ payload }) {
  try {
    const { status, data } = yield call(api.post, '/auth/password/forgot', payload);
    if (status === 200) {
      yield put(RecoverPasswordActions.sendEmailSuccess(data));
    }else{
      Sentry.captureMessage('sendEmail failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(RecoverPasswordActions.sendEmailError(error.response.data));
  }
}

function* sendEmailWatcher() {
  yield takeLatest(RecoverPasswordTypes.SEND_EMAIL, sendEmail);
}

function* newPassword({ payload }) {
  try {
    const { status, data } = yield call(
      api.post,
      '/auth/password/reset',
      payload
    );
    if (status === 200) {
      yield put(RecoverPasswordActions.newPasswordSuccess(data));
    }else{
      Sentry.captureMessage('newPassword failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(RecoverPasswordActions.newPasswordError(error.response.data));
  }
}

function* newPasswordWatcher() {
  yield takeLatest(RecoverPasswordTypes.NEW_PASSWORD, newPassword);
}

export default function* rootSaga() {
  yield all([fork(sendEmailWatcher), fork(newPasswordWatcher)]);
}
